import { cn } from '@/lib/utils';
import { FC } from 'react';
import { ChartLegendItem } from './types';

export type StackedBarChartLegendProps = {
  items: ChartLegendItem[];
  className?: string;
  itemClassName?: string;
  showProgressBar?: boolean;
  showPercentage?: boolean;
};

export const StackedBarChartLegend: FC<StackedBarChartLegendProps> = ({
  items,
  className,
  itemClassName,
  showProgressBar = true,
  showPercentage = true,
}) => {
  if (!items || items.length === 0) return null;

  return (
    <div className={cn('flex flex-col justify-center gap-2.5', className)}>
      {items.map((item) => (
        <div key={item.key} className={cn('flex flex-col gap-1', itemClassName)}>
          <div className="flex items-center gap-2">
            <span className="size-2 rounded-full shrink-0" style={{ backgroundColor: item.color }} aria-hidden="true" />
            <span
              className="text-xs font-bold truncate text-foreground-heading"
              style={{ color: item.color }}
              title={item.name}
            >
              {item.name}
            </span>
          </div>
          {showProgressBar && (
            <div className="flex items-center gap-2">
              <div className="flex-1 h-1 bg-surface-track rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-300"
                  style={{
                    backgroundColor: item.color,
                    width: `${Math.min(Math.max(item.percentage, 0), 100)}%`,
                  }}
                />
              </div>
              {showPercentage && (
                <span className="text-xs font-semibold text-foreground-detail w-8 text-right shrink-0">
                  {item.percentage}%
                </span>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StackedBarChartLegend;
